var map = {
	"./da/agreement.json": 5798,
	"./da/annualReport.json": 2784,
	"./da/auth.json": 8861,
	"./da/common.json": 6251,
	"./da/errors.json": 2916,
	"./da/solarPark.json": 3273,
	"./da/terms.json": 535,
	"./en/agreement.json": 8855,
	"./en/annualReport.json": 1256,
	"./en/auth.json": 4246,
	"./en/common.json": 6910,
	"./en/errors.json": 6178,
	"./en/solarPark.json": 6534,
	"./en/terms.json": 7118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8225;